import { Checkbox } from '@weareopenr/component-library';
import { SYNC_MESSAGE_TEXT } from 'src/constants';

export const SyncAcknowledgeChangeCheckBox = ({
  acknowledgeChange,
  acceptChanges,
  productsCount,
  stepCount,
}: {
  acknowledgeChange: boolean;
  acceptChanges: () => void;
  productsCount: number;
  stepCount: number;
}) => {
  const acknowledgementAction: string = SYNC_MESSAGE_TEXT[stepCount];

  return (
    <div>
      <Checkbox
        label={`I acknowledge that I am accepting ${productsCount} ${acknowledgementAction} products`}
        name="acknowledge-step"
        labelWeight="regular"
        onChange={acceptChanges}
        checked={acknowledgeChange}
      />
    </div>
  );
};
